<template>
  <!-- 分享组件 -->
  <div class="v-share">
    <!-- h5分享提示 -->
    <div v-show="showTip" class="v-share__tip">
      <div class="v-share__tip--btn" @click="handleTipClose">知道了</div>
    </div>
  </div>
</template>

<script>
import wx from "weixin-js-sdk"; // 引入wxjs
import service from "@utils/service.js";
import ua from "@tp/ua";
import {
  getDurationStorage,
  setDurationStorage,
  clearStorage,
} from "@utils/storage";
import MGUtils from "@tp/h5utils";
import Api from "@utils/api";
window.wx = wx;

export default {
  name: "VShare",

  data() {
    return {
      showTip: false, // 分享浮层
      /** 初始化状态 */
      hasConfig: false,
      /** toShare重试次数，防止初始化未完成就调用分享，延时1s调用一次，尝试5次 */
      toShareRetry: 0,
      // 缓存
      storageKey: "wx-sign-h5",
      configRetry: 0,
    };
  },
  components: {},

  props: {
    shareData: {
      type: Object,
      default: () => {},
    },
  },
  mounted() {},

  methods: {
    // 关闭分享浮层
    handleTipClose() {
      this.showTip = false;
    },
    // 调用芒果app分享
    shareMgapp() {
      window.MgtvApi.callhandler("showShare");
    },

    // 设置分享信息
    shareInitData(shareData, needCb = false) {
      console.log("设置分享信息mg", shareData, needCb);
      // this.shareMgData(shareData);

      // // 微信
      // this.shareWxData(shareData);

      MGUtils.tpShare(
        {
          url: Api.getSignWxSdk, // 签名接口
          title: shareData.title, // 分享标题
          desc: shareData.desc, // 分享描述
          imgUrl: shareData.imgUrl, // 分享图标
          link: shareData.link,
        },
        () => {
          console.log("分享成功");
          if (needCb) {
            this.$emit("shareSuccess");
          }
        }
      );
    },

    // 设置芒果app分享信息
    shareMgData(shareData) {
      if (!ua.isImgo()) {
        return;
      }
      window.MgtvApi.callhandler("showShareMenus", {
        title: shareData.title,
        desc: shareData.desc,
        shareUrl: shareData.link,
        shareIcon: shareData.imgUrl,
        customInfo: {
          //各自数据分享数据
          微信: {
            title: shareData.title,
            desc: shareData.desc,
            url: shareData.link,
            img: shareData.imgUrl,
          },
          朋友圈: {
            title: shareData.title,
            desc: shareData.desc,
            url: shareData.link,
            img: shareData.imgUrl,
          },
          新浪: {
            title: shareData.title,
            desc: shareData.desc,
            url: shareData.link,
            img: shareData.imgUrl,
          },
          QQ: {
            title: shareData.title,
            desc: shareData.desc,
            url: shareData.link,
            img: shareData.imgUrl,
          },
          QQ空间: {
            title: shareData.title,
            desc: shareData.desc,
            url: shareData.link,
            img: shareData.imgUrl,
          },
        },
      });
    },

    // 设置微信分享信息
    shareWxData(shareData) {
      // /**微信 */
      if (ua.isWx()) {
        if (!this.hasConfig) {
          console.warn("[wx sdk] config未完成");

          const timer = setTimeout(() => {
            if (this.toShareRetry >= 5) {
              console.error("[wx sdk] config失败");
              return;
            }

            this.toShareRetry = this.toShareRetry + 1;
            console.info("[wx sdk] toShare重试", this.toShareRetry);
            this.shareWx(shareData);
            clearTimeout(timer);
          }, 1000);

          return;
        }
        this.shareWx(shareData);
      }
    },

    // 调用微信的自定义分享
    shareWx(shareData) {
      console.log("shareWx,shareData————————", shareData);
      console.warn(location.href, "location.hreflocation.hreflocation.href");

      const signCache = getDurationStorage(this.storageKey, 2);
      console.log("读取缓存签名signCache", signCache);

      if (signCache) {
        console.log("[wx sdk] 读取缓存签名", signCache);
        this.wxConfig(signCache, shareData);
        return;
      }
      const save = {
        url: location.href.split("#")[0], // 只需要传当前页面地址 .replace("https://", "")
      };

      service.getSignWxh5Iptv().then((res) => {
        const config = res.data || {};
        if (config) {
          setDurationStorage(this.storageKey, {
            ...config,
            signUrl: save.url,
            url: save.url,
          });
          console.log("调用微信签名接口成功", res);
          setTimeout(() => {
            this.wxConfig({ ...config, signUrl: save.url }, shareData);
          }, 1500);
        }
      });
    },

    wxConfig(config, shareData) {
      console.log("wxConfig的config", config);
      console.log("wxConfig分享info————————", shareData);
      let info = {};
      if (shareData) {
        info = shareData;
      } else {
        info = this.shareData;
      }
      console.log("shareWx,info————————", info);
      wx.config({
        // debug: true, // 开启调试模式
        appId: config.appId, // appID 公众号的唯一标识
        timestamp: config.timestamp, // 生成签名的时间戳
        nonceStr: config.nonceStr, //  生成签名的随机串
        signature: config.signature, // 生成的签名
        jsApiList: [
          // "updateAppMessageShareData", // 分享到朋友
          // "updateTimelineShareData", // 分享到朋友圈
          "onMenuShareTimeline", // 分享到朋友圈
          "onMenuShareAppMessage", // 分享到朋友圈
          "hideMenuItems", // 隐藏菜单
        ],
        openTagList: ["wx-open-launch-app"], // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
      });
      wx.ready(() => {
        console.log("[wx sdk] 微信sdk注册完成");
        this.hasConfig = true; // 延迟600ms确保SDK完全初始化
        setTimeout(() => {
          //点击要去分享
          wx.onMenuShareTimeline({
            ...info,
            trigger: (res) => {
              console.log("用户点击了分享按钮3", res);
            },
            success: (res) => {
              // if (info.isUserShare) {
              //   self.success();
              // }
              console.log("分享成功3", res);
            },
            fail: (err) => {
              console.error("分享失败3", err);
            },
          });
          wx.onMenuShareAppMessage({
            ...info,
            trigger: (res) => {
              console.log("用户点击了分享按钮4", res);
            },
            success: (res) => {
              // if (info.isUserShare) {
              //   self.success();
              // }
              console.log("分享成功4", res);
            },
            fail: (err) => {
              console.error("分享失败4", err);
            },
          });
          wx.hideMenuItems({
            menuList: [
              "menuItem:share:qq", // 分享到 QQ
              "menuItem:share:qzone", // 分享到 QQ 空间
            ],
          });
        }, 600);
      });
      wx.error((res) => {
        if (this.configRetry < 1) {
          this.configRetry = this.configRetry + 1;
          /**重新注册，重置次数 */
          this.toShareRetry = 0;
          clearStorage(this.storageKey);
          this.shareWx(info);
          console.log("[wx sdk] 微信sdk注册失败", res);
        }
      });
    },

    getShareInfo() {
      /**芒果App（需添加渠道码） */
      if (ua.isImgo()) {
        this.shareMgapp();
        return;
      }

      this.showTip = true;
    },
  },
};
</script>

<style lang="less">
// 分享组件
.v-share {
  &__tip {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 999;
    background: rgba(0, 0, 0, 0.8) url("../assets/image/guide.png") no-repeat;
    background-size: 76% auto;
    background-position: 70px 16px;

    &--btn {
      position: absolute;
      top: 412px;
      left: 50%;
      transform: translateX(-50%);
      width: 112px;
      font-size: 16px;
      height: 40px;
      background-color: rgba(255, 255, 255, 0.2);
      color: #fff;
      border: solid 1px #fff;
      border-radius: 21px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
